import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MemberInfoService } from 'src/app/services/member-info.service';
import { AttestationPeriod, MemberLabAttestation } from 'src/app/services/models/member-lab-attestation';
import { SessionService } from 'src/app/services/session.service';
import { UiUtility } from 'src/app/utils/ui-utility';
import { CodeNamePair } from '../../../../services/models/code-name-pair';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-member-labs-attestation',
  templateUrl: './member-labs-attestation.component.html',
  styleUrl: './member-labs-attestation.component.scss'
})
export class MemberLabsAttestationComponent implements OnInit{
  @Input() memberCIN: string;
  @Output() onsavesuccess = new EventEmitter();
  @Output() onsavefailed = new EventEmitter();
  @Output() onchange = new EventEmitter();

  public measurementperiodlist : CodeNamePair[] = [];
  public labs: CodeNamePair[] = [];
  public attestationPeriods: AttestationPeriod[] = [];
  public selectedmeasurementperiod: CodeNamePair;
  public currentmeasurementperiod: CodeNamePair;
  public _selectedlab: CodeNamePair;
  public memberLabAttestation: MemberLabAttestation;
  public changeOccurred: boolean;
  public showConfirmMessage: boolean;
  public confirmMessage: string;
  public completionscore: number = 0;
  public today: Date = new Date();

  constructor(private memberService: MemberInfoService, 
    private sessionService: SessionService,
    private confirmationService: ConfirmationService) {
      
  }

  ngOnInit(): void {

    this.labs = [
      { name: 'CBC', code: 'CBC' },
      { name: 'BMP', code: 'BMP' },
      { name: 'TSH', code: 'TSH' },
      { name: 'LFT', code: 'LFT' },
      { name: 'HbA1c', code: 'HGB' },
      { name: 'Fasting Lipid Panel', code: 'FLP' }
    ];  

    this.memberService.getMembersLabAttestationPeriods().subscribe(x=>{
      this.attestationPeriods = x;
      this.measurementperiodlist = [];

      x.forEach(y=>{
        let pair: CodeNamePair = new CodeNamePair();
        pair.code = y.measurementPeriod;
        pair.name = y.description;

        this.measurementperiodlist.push(pair);
      });

      this.selectedmeasurementperiod = this.measurementperiodlist[0];
      this.currentmeasurementperiod = this.selectedmeasurementperiod;
      this.selectedlab = this.labs[0];
      this.refreshNewMeasurementPeriod();
    });
  }

  public get canAttest() : boolean {
    
    if(this.sessionService.isInternalUser) {
      return false;
    }
    else {

      let attestationPeriod:AttestationPeriod = this.attestationPeriods.find(x=>x.measurementPeriod.trim().toUpperCase() === this.selectedmeasurementperiod.code.trim().toUpperCase());
      return (attestationPeriod) ? attestationPeriod.availableToAttest : false;

    }
  }

  public get selectedlab() : CodeNamePair {
    return this._selectedlab;
  }

  public set selectedlab(val:CodeNamePair) {
    var currentval:CodeNamePair = this._selectedlab;

    this._selectedlab = val;

    if(!this._selectedlab) {
      this._selectedlab = currentval;
    }
  }

  public refreshNewMeasurementPeriod() {
    this.memberLabAttestation = null;    
    this.memberService.getMembersLabAttestation(this.memberCIN, this.selectedmeasurementperiod.code).subscribe(x=>{
      if(x.length > 0) {
        this.memberLabAttestation = x[0];      
      }
      else {
        this.memberLabAttestation = new MemberLabAttestation();
        this.memberLabAttestation.memberCIN = this.memberCIN;
        this.memberLabAttestation.measurementPeriod = this.selectedmeasurementperiod.code;
      }      

      if(this.memberLabAttestation) {
        if(this.memberLabAttestation.cbC_WBC == null)
          this.memberLabAttestation.cbC_WBC = '';
        if(this.memberLabAttestation.cbC_Hgb == null)
          this.memberLabAttestation.cbC_Hgb = '';

        if(this.memberLabAttestation.bmP_BUN == null)
          this.memberLabAttestation.bmP_BUN = '';    
        if(this.memberLabAttestation.bmP_K_Hgb == null)
          this.memberLabAttestation.bmP_K_Hgb = '';                
        if(this.memberLabAttestation.bmP_Scr == null)
          this.memberLabAttestation.bmP_Scr = '';    
        
        if(this.memberLabAttestation.lfT_ALT == null)        
          this.memberLabAttestation.lfT_ALT = '';
        if(this.memberLabAttestation.lfT_AST == null)        
          this.memberLabAttestation.lfT_AST = '';        
        if(this.memberLabAttestation.lfT_AlKphos == null)                  
          this.memberLabAttestation.lfT_AlKphos = '';        

        if(this.memberLabAttestation.fastingLipidPanel_HDL == null)        
          this.memberLabAttestation.fastingLipidPanel_HDL = '';
        if(this.memberLabAttestation.fastingLipidPanel_LDL == null)        
          this.memberLabAttestation.fastingLipidPanel_LDL = '';        
        if(this.memberLabAttestation.fastingLipidPanel_TotalCholesterol == null)                  
          this.memberLabAttestation.fastingLipidPanel_TotalCholesterol = '';                    
        if(this.memberLabAttestation.fastingLipidPanel_Triglyceride == null)                  
          this.memberLabAttestation.fastingLipidPanel_Triglyceride = '';     

        if(this.memberLabAttestation.scoreValue == null)                  
          this.updateScore();
      }                 
      
      this.oninputchange();
      this.changeOccurred = false;
    });
  }

  public onMPChange($event) {

    if(this.changeOccurred) {
      this.confirmationService.confirm({
        header: 'Lab Review Attestation',
        message:  "There are changes in current measurement period - " + this.currentmeasurementperiod.code + ". Do you still want to continue?",
        key: 'continueDialog',
        accept: () => {
          this.refreshNewMeasurementPeriod();
        },
        reject: () => {
          this.selectedmeasurementperiod = this.currentmeasurementperiod;
        }
      });
    }
    else {
      this.currentmeasurementperiod = this.selectedmeasurementperiod;
      this.refreshNewMeasurementPeriod();
    }
  }
  
  public onChange() {
    this.updateScore();
  }

  public oninputchange() {
    this.onchange.emit();
    this.changeOccurred = true;
  }

  public saveLabAttestation() {
    this.memberService.updateMemberLabAttestation(this.memberLabAttestation).subscribe(x=>{
      this.onsavesuccess.emit();
      this.changeOccurred = false;
    },
    (error)=>{
      this.onsavefailed.emit();
    });
  }

  public labState(listitem:CodeNamePair) : number {

    var returnItem: number = 0;
    var labDate: Date;
    var reviewDate: Date;

    if(this.memberLabAttestation) {
      if(listitem.code == 'CBC') {
        labDate = this.memberLabAttestation.cbC_DateOfLabs;
        reviewDate = this.memberLabAttestation.cbC_DateOfReview;
      }
      else if(listitem.code == 'BMP') {
        labDate = this.memberLabAttestation.bmP_DateOfLabs;
        reviewDate = this.memberLabAttestation.bmP_DateOfReview;
      }
      else if(listitem.code == 'TSH') {
        labDate = this.memberLabAttestation.tsH_DateOfLabs;
        reviewDate = this.memberLabAttestation.tsH_DateOfReview;
      }
      else if(listitem.code == 'HGB') {
        labDate = this.memberLabAttestation.hgB_DateOfLabs;
        reviewDate = this.memberLabAttestation.hgB_DateOfReview;
      }      
      else if(listitem.code == 'LFT') {
        labDate = this.memberLabAttestation.lfT_DateOfLabs;
        reviewDate = this.memberLabAttestation.lfT_DateOfReview;
      }
      else if(listitem.code == 'FLP') {
        labDate = this.memberLabAttestation.fastingLipidPanel_DateOfLabs;
        reviewDate = this.memberLabAttestation.fastingLipidPanel_DateOfReview;
      }
    }


    if(UiUtility.isNullUndefinedOrEmpty(labDate) && UiUtility.isNullUndefinedOrEmpty(reviewDate))
      returnItem = 1;
    else if(UiUtility.isNullUndefinedOrEmpty(labDate) || UiUtility.isNullUndefinedOrEmpty(reviewDate))
      returnItem = 2;
    else 
      returnItem = 3;

    return returnItem;
  }

  public updateScore() {
    var completed: number = 0;
    this.labs.forEach(x=>{
      var result: number = this.labState(x);
      if(result == 3)
        completed = completed + 1;
    });

    this.memberLabAttestation.scoreValue = completed;
  }

  public validate(): any {

    var result = {
      "valid": true,
      "error": ''
    };

    var noCBCCheck: boolean = UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.cbC_DateOfLabs) && UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.cbC_DateOfReview);
    var noBMPCheck: boolean = UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.bmP_DateOfLabs) && UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.bmP_DateOfReview);
    var noTSHCheck: boolean = UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.tsH_DateOfLabs) && UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.tsH_DateOfReview);
    var noHGBCheck: boolean = UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.hgB_DateOfLabs) && UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.hgB_DateOfReview);
    var noLFTCheck: boolean = UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.lfT_DateOfLabs) && UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.lfT_DateOfReview);
    var noFLPCheck: boolean = UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.fastingLipidPanel_DateOfLabs) && UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.fastingLipidPanel_DateOfReview);

    if(!noCBCCheck) {
      if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.cbC_DateOfLabs)) {
        result.valid = false;
        result.error = "Invalid CBC Date of Labs";
      }
      else if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.cbC_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid CBC Date of Review";
      }    
      else if ( new Date(this.memberLabAttestation.cbC_DateOfLabs) > new Date(this.memberLabAttestation.cbC_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid CBC date of Review. Date of review cannot be prior to Date of lab.";        
      }
      else if ((!this.memberLabAttestation.cbC_Hgb || this.memberLabAttestation.cbC_Hgb.trim() == '') 
                && (!this.memberLabAttestation.cbC_WBC || this.memberLabAttestation.cbC_WBC.trim() == '')) {
        result.valid = false;
        result.error = "Atleast one lab value needs to be entered for CBC.";
      }
    }

    if(!noBMPCheck) {
      if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.bmP_DateOfLabs)){
        result.valid = false;
        result.error = "Invalid BMP Date of Labs";
      }    
      else if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.bmP_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid BMP Date of Review";
      }
      else if ( new Date(this.memberLabAttestation.bmP_DateOfLabs) > new Date(this.memberLabAttestation.bmP_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid BMP date of Review. Date of review cannot be prior to Date of lab.";        
      }      
      else if ((this.memberLabAttestation.bmP_BUN || this.memberLabAttestation.bmP_BUN.trim() == '') 
                  && (!this.memberLabAttestation.bmP_K_Hgb || this.memberLabAttestation.bmP_K_Hgb.trim() == '') 
                    && (!this.memberLabAttestation.bmP_Na || this.memberLabAttestation.bmP_Na.trim() == '') 
                      && (!this.memberLabAttestation.bmP_Scr || this.memberLabAttestation.bmP_Scr.trim() == '')) {
        result.valid = false;
        result.error = "Atleast one lab value needs to be entered for BMP.";
      }      
    }

    if(!noTSHCheck) {
      if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.tsH_DateOfLabs)) {
        result.valid = false;
        result.error = "Invalid TSH Date of Labs";                  
      }
      else if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.tsH_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid TSH Date of Review";                  
      }
      else if ( new Date(this.memberLabAttestation.tsH_DateOfLabs) > new Date(this.memberLabAttestation.tsH_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid TSH date of Review. Date of review cannot be prior to Date of lab.";        
      }            
    }

    if(!noHGBCheck) {
      if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.hgB_DateOfLabs)) {
        result.valid = false;
        result.error = "Invalid HgbA1c Date of Labs";                  
      }
      else if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.hgB_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid HgbA1c Date of Review";                  
      }
      else if ( new Date(this.memberLabAttestation.hgB_DateOfLabs) > new Date(this.memberLabAttestation.hgB_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid HGB date of Review. Date of review cannot be prior to Date of lab.";        
      }             
    }    

    if(!noLFTCheck) {
      if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.lfT_DateOfLabs)) {
        result.valid = false;
        result.error = "Invalid LFT Date of Labs";      
      }
      else if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.lfT_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid LFT Date of Review";            
      }            
      else if ( new Date(this.memberLabAttestation.lfT_DateOfLabs) > new Date(this.memberLabAttestation.lfT_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid LFT date of Review. Date of review cannot be prior to Date of lab.";        
      }            
      else if ((!this.memberLabAttestation.lfT_ALT || this.memberLabAttestation.lfT_ALT.trim() == '') 
                  && (!this.memberLabAttestation.lfT_AST || this.memberLabAttestation.lfT_AST.trim() == '')
                    && (!this.memberLabAttestation.lfT_AlKphos || this.memberLabAttestation.lfT_AlKphos.trim() == '')) {
        result.valid = false;
        result.error = "Atleast one lab value needs to be entered for LFT.";
      }                         
    }

    if(!noFLPCheck) {
      if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.fastingLipidPanel_DateOfLabs)) {
        result.valid = false;
        result.error = "Invalid Fasting Lipid Panel Date of Labs";
      }
      else if(UiUtility.isNullUndefinedOrEmpty(this.memberLabAttestation.fastingLipidPanel_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid Fasting Lipid Panel Date of Review";
      }
      else if ( new Date(this.memberLabAttestation.fastingLipidPanel_DateOfLabs) > new Date(this.memberLabAttestation.fastingLipidPanel_DateOfReview)) {
        result.valid = false;
        result.error = "Invalid Fasting Lipid Panel date of Review. Date of review cannot be prior to Date of lab.";        
      }   
      else if ((!this.memberLabAttestation.fastingLipidPanel_HDL || this.memberLabAttestation.fastingLipidPanel_HDL.trim() == '') 
                && (!this.memberLabAttestation.fastingLipidPanel_LDL || this.memberLabAttestation.fastingLipidPanel_LDL.trim() == '') 
                  && (!this.memberLabAttestation.fastingLipidPanel_TotalCholesterol || this.memberLabAttestation.fastingLipidPanel_TotalCholesterol.trim() == '') 
                    && (!this.memberLabAttestation.fastingLipidPanel_Triglyceride || this.memberLabAttestation.fastingLipidPanel_Triglyceride.trim() == '')) {
        result.valid = false;
        result.error = "Atleast one lab value needs to be entered for fasting lipid panel.";
      }                             
    }

    return result;
  }
}
